import axios from 'axios';
import { Address, QualificationResult, LeadRequest, LeadResponse } from '../types';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api/v1';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 * Resolve address using Google Places
 */
export const resolveAddress = async (
  address: string,
  googlePlaceId?: string
): Promise<{ success: boolean; count: number; addresses: Address[]; message?: string }> => {
  const response = await api.post('/address/resolve', {
    address,
    google_place_id: googlePlaceId,
  });
  return response.data;
};

/**
 * Check service qualification for a location
 */
export const checkQualification = async (
  locationId: string,
  latitude: number,
  longitude: number,
  email: string,
  customerType: string = 'residential',
  address?: {
    formatted_address?: string;
    suburb?: string;
    state?: string;
    postcode?: string;
  }
): Promise<QualificationResult> => {
  const response = await api.post('/qualify', {
    location_id: locationId,
    latitude: latitude,
    longitude: longitude,
    email: email,
    customer_type: customerType,
    formatted_address: address?.formatted_address,
    suburb: address?.suburb,
    state: address?.state,
    postcode: address?.postcode,
  });
  return response.data;
};

/**
 * Create a new lead
 */
export const createLead = async (leadData: LeadRequest): Promise<LeadResponse> => {
  try {
    const response = await api.post('/lead/create', leadData);
    return response.data;
  } catch (error: any) {
    if (error.response) {
      return error.response.data;
    }
    throw error;
  }
};
